export const COOKIE_NAMES = {
  targetPool: 'targetPool',
  organization: 'organization',
} as const;

export type CookieName = (typeof COOKIE_NAMES)[keyof typeof COOKIE_NAMES];
